/**
 * Feature flag for showing pricing and the interactive price estimator.
 * Set NEXT_PUBLIC_SHOW_PRICING='true' in .env to enable.
 */
export const SHOW_PRICING = process.env.NEXT_PUBLIC_SHOW_PRICING === 'true';

/**
 * Feature flag for showing scheduled/draft articles before their publish date.
 * Set NEXT_PUBLIC_SHOW_FUTURE_POSTS='true' in .env or run in development to enable.
 */
export const SHOW_FUTURE_POSTS = 
  process.env.NODE_ENV === 'development' && 
  process.env.NEXT_PUBLIC_SHOW_FUTURE_POSTS === 'true';

/**
 * Feature flag for showing the Templates section in navigation.
 * Set NEXT_PUBLIC_SHOW_TEMPLATES='true' in .env to enable.
 */
export const SHOW_TEMPLATES = false; // process.env.NEXT_PUBLIC_SHOW_TEMPLATES === 'true';
